module.exports = __webpack_public_path__ + "img/03黑色金属制造业.9353cc76.jpg";